export const STEP_TITLE_MAP_COMMON = {
  warning: 'Warning',
  success: 'Successful',
  failure: 'Error',
};
